export const getLocationSearch = state => state.locationSearch.locationSearchData;
export const getError = state => state.locationSearch.error;